module.exports = __webpack_public_path__ + "static/icerik-pazarlama-fc50407719acbc9ad620220425d9b93e.png";